import React, { useEffect, useRef } from "react";
import ohlogo from "/src/assets/olympic-holidays-logo.svg";
import abtaLogo from "/src/assets/abta-logo.svg";
import atolLogo from "/src/assets/atol.png";
import { useSessionStorage } from "@uidotdev/usehooks";
import { SALES_PHONE } from "/src/config/constants.js";

const Header = ({ defaultSearch, waitForOverride, hideSearch }) => {
    const searchContainerRef = useRef(null);
    const searchOverviewRef = useRef(null);

    // window.OlympicSearch is safe to call repeatedly for the same node - it
    // reuses the React root, so a defaultSearch change re-seeds the widget
    // rather than stacking a second root on the container.
    useEffect(
        function () {
            if (hideSearch) return;
            if (defaultSearch) {
                window.OlympicSearch({
                    mountNode: searchContainerRef.current,
                    overviewNode: searchOverviewRef.current,
                    baseUrl: window.searchUrl,
                    bookingEngineBaseUrl: "",
                    specificSearch: defaultSearch,
                });
            }
        },
        [defaultSearch, hideSearch]
    );
    return (
        <header className="relative z-50 mb-6">
            <div className="bg-white rounded-[24px] mb-6">
                <div className="flex items-center px-4 py-6 gap-4">
                    <div className="flex items-center">
                        <a href={window.wwwUrl} className="flex items-center space-x-3">
                            <img
                                src={ohlogo}
                                alt="Olympic Holidays Logo"
                                className="h-[67px] w-auto"
                            />
                        </a>
                    </div>

                    <div className="flex-1 flex justify-end md:justify-center items-center">
                        <div className="max-w-[380px] flex items-center gap-4">
                            {!hideSearch && (
                                <button
                                    onClick={() => window.toggleSearchForm()}
                                    type="button"
                                    className="btn-primary text-white p-2 inline-flex items-center justify-center rounded-full bg-emp md:hidden"
                                >
                                    <span className="h-[32px] flex items-center justify-center px-4">
                                        Edit Search
                                    </span>
                                    <svg
                                        width="19"
                                        height="18"
                                        viewBox="0 0 19 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M11.8043 11.25L12.9293 12.375M13.2543 14.2689C12.821 13.8356 12.821 13.1332 13.2543 12.7C13.6875 12.2667 14.3899 12.2667 14.8232 12.7L16.3543 14.2311C16.7876 14.6644 16.7876 15.3668 16.3543 15.8C15.9211 16.2333 15.2187 16.2333 14.7854 15.8L13.2543 14.2689ZM12.9293 7.125C12.9293 4.22551 10.5788 1.875 7.67932 1.875C4.77983 1.875 2.42932 4.22551 2.42932 7.125C2.42932 10.0245 4.77983 12.375 7.67932 12.375C10.5788 12.375 12.9293 10.0245 12.9293 7.125Z"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        ></path>
                                    </svg>
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="flex items-center">
                        <div className="hidden lg:flex gap-2 items-stretch">
                            <div className="flex items-center">
                                <img src={abtaLogo} alt="ABTA" className="h-[32px] w-auto" />
                            </div>
                            <div className="flex items-center">
                                <img
                                    src={atolLogo}
                                    alt="ATOL Protected"
                                    className="h-[50px] w-auto"
                                />
                            </div>
                            <div className="flex items-center">
                                <div>
                                    <div className="text-secondary text-lg">{SALES_PHONE}</div>
                                    <div className="text-content_2 text-sm">
                                        Open 9AM to 7PM today
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {!hideSearch && <div ref={searchContainerRef}></div>}
        </header>
    );
};
export default Header;
